import { Info, User, Stethoscope } from "lucide-react";

const points = [
  {
    icon: Info,
    title: "Recommandations informatives",
    text: "Les analyses, scores et programmes générés par Lift AI sont fournis à titre informatif et éducatif.",
  },
  {
    icon: User,
    title: "Tu restes responsable",
    text: "Tu es seul responsable de la pratique de tes entraînements, de ta sécurité et de ton suivi physique.",
  },
  {
    icon: Stethoscope,
    title: "Ne remplace pas un avis médical",
    text: "Lift AI ne se substitue en aucun cas à l'avis d'un professionnel de santé ou d'un coach certifié.",
  },
];

export default function Terms() {
  return (
    <section
      id="conditions"
      data-testid="terms-section"
      className="py-24 lg:py-32 px-6 lg:px-10 bg-white"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16">
          <p className="text-sm font-medium text-violet-600 mb-4 uppercase tracking-wider">
            Conditions d'utilisation
          </p>
          <h2
            data-testid="terms-title"
            className="text-4xl sm:text-5xl font-semibold tracking-tight leading-[1.1] text-neutral-950"
          >
            Utilise Lift AI en toute conscience.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {points.map((p, i) => (
            <div
              key={p.title}
              data-testid={`terms-point-${i}`}
              className="border-l-2 border-neutral-200 pl-6 hover:border-violet-500 transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-xl bg-neutral-100 flex items-center justify-center mb-5">
                <p.icon size={18} className="text-neutral-950" />
              </div>
              <h3 className="text-lg font-semibold tracking-tight text-neutral-950 mb-2">
                {p.title}
              </h3>
              <p className="text-base text-neutral-600 leading-relaxed">
                {p.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
